module.exports = __webpack_public_path__ + "img/132.1691ce0e.jpg";